import InventoryItemInterface from 'app/interfaces/InventoryItemInterface';
import LootInterface from 'app/interfaces/LootInterface';

export interface ArtifactLike {
    artifact_price?: number | string | null
    calculated_price?: number | string | null
    image?: InventoryItemInterface['image'] | {url: string}
    max_calculated_price?: number | string | null
    name?: string
    price?: number | string | null
    title?: string
}

export const artifactPrice = (artifact: ArtifactLike): number | string | null => artifact.calculated_price ??
    artifact.artifact_price ??
    artifact.price ??
    artifact.max_calculated_price ??
    null;

export const artifactToLoot = (artifact: ArtifactLike): LootInterface => ({
    bonus: null,
    bonus_amount: 0,
    calculated_price: artifactPrice(artifact),
    money_amount: 0,
    points_amount: 0,
    recipe: artifact as InventoryItemInterface,
    steam_skin: null,
    title: artifact.name || artifact.title || ''
});
